// src/components/SkeletonLoader.jsx
import styles from './SkeletonLoader.module.css';

export function SkeletonCard() {
  return (
    <div className={styles.skCard}>
      <div className={styles.skCard__header}>
        <div className={styles.skCard__titleGroup}>
          <div className={`${styles.block} ${styles['w-3-4']}`} style={{ height: '24px' }} />
          <div className={`${styles.block} ${styles['w-1-2']}`} style={{ height: '16px' }} />
        </div>
        <div className={styles.block} style={{ height: '24px', width: '64px', borderRadius: '9999px' }} />
      </div>
      <div className={styles.skCard__lines}>
        <div className={`${styles.block} ${styles['w-full']}`} style={{ height: '16px' }} />
        <div className={`${styles.block} ${styles['w-5-6']}`} style={{ height: '16px' }} />
      </div>
      <div className={styles.skCard__actions}>
        <div className={styles.block} style={{ height: '36px', width: '96px' }} />
        <div className={styles.block} style={{ height: '36px', width: '96px' }} />
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  return (
    <div className={styles.skTable}>
      <div className={styles.skTable__header}>
        <div className={`${styles.block} ${styles['w-1-3']}`} style={{ height: '24px' }} />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={styles.skTable__row}>
          <div className={styles.skTable__rowInner}>
            <div className={styles.skTable__rowText}>
              <div className={`${styles.block} ${styles['w-1-4']}`} style={{ height: '16px' }} />
              <div className={`${styles.block} ${styles['w-1-3']}`} style={{ height: '12px' }} />
            </div>
            <div className={styles.block} style={{ height: '32px', width: '80px' }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonChart() {
  return (
    <div className={styles.skChart}>
      <div className={styles.skChart__inner}>
        <div className={`${styles.block} ${styles['w-1-3']}`} style={{ height: '24px' }} />
        <div className={`${styles.block} ${styles['w-1-4']}`} style={{ height: '16px' }} />
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className={styles.skChart__bar}
            /* Heights intentionally varied — inline is appropriate for generative values */
            style={{ height: `${[80, 140, 60, 120, 90][i]}px` }}
          />
        ))}
      </div>
    </div>
  );
}

export function SkeletonMetricCard() {
  return (
    <div className={styles.skMetric}>
      <div className={styles.skMetric__inner}>
        <div className={styles.skMetric__text}>
          <div className={`${styles.block} ${styles['w-1-2']}`} style={{ height: '16px' }} />
          <div className={`${styles.block} ${styles['w-2-3']}`} style={{ height: '32px' }} />
          <div className={`${styles.block} ${styles['w-1-3']}`} style={{ height: '12px' }} />
        </div>
        <div className={styles.skMetric__icon} />
      </div>
    </div>
  );
}

export function SkeletonList({ items = 3 }) {
  return (
    <div className={styles.skList}>
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} className={styles.skList__item}>
          <div className={styles.skList__avatar} />
          <div className={styles.skList__text}>
            <div className={`${styles.block} ${styles['w-1-3']}`} style={{ height: '16px' }} />
            <div className={`${styles.block} ${styles['w-1-2']}`} style={{ height: '12px' }} />
          </div>
          <div className={styles.block} style={{ height: '32px', width: '80px' }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div className={styles.skDash}>
      <div className={styles.skDash__metrics}>
        <SkeletonMetricCard />
        <SkeletonMetricCard />
        <SkeletonMetricCard />
        <SkeletonMetricCard />
      </div>
      <div className={styles.skDash__charts}>
        <SkeletonChart />
        <SkeletonChart />
      </div>
      <SkeletonList items={5} />
    </div>
  );
}
